import axios from './axiosService';

export default {
  getPresentationFiles(presentationID) { // MLD-6877
    return axios.get(`/api/presentations/${presentationID}/files`)
      .then(response => response.data);
  },
  getPresentation(presentationID) {
    return axios.get(`/api/presentations/${presentationID}?include_files=false`)
      .then(response => response.data);
  },
  getPageFilesFor(presentationID) {
    return axios.get(`/api/presentations/${presentationID}/pages`)
      .then(response => response.data);
  },
}
